import * as Sentry from '@sentry/nextjs';

export default Sentry;
